import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dataFilter'
})
export class DataFilterPipe implements PipeTransform {

  transform(array: any[], query: string): any {
    if (query) {
      console.log("array",array);
      return _.filter(array, row => row.Name.indexOf(query) > -1);
    }
    return array;
  }
}
